import { render, staticRenderFns } from "./LevelRewardDetails.vue?vue&type=template&id=38f0455f&scoped=true"
import script from "./LevelRewardDetails.vue?vue&type=script&lang=js"
export * from "./LevelRewardDetails.vue?vue&type=script&lang=js"
import style0 from "./LevelRewardDetails.vue?vue&type=style&index=0&id=38f0455f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f0455f",
  null
  
)

export default component.exports